<template>
  <b-row>
    <b-col cols="12" class="mb-5">
      <PageTitle title="Produtos com preço cadastrado" />
    </b-col>
    <b-col cols="12" class="mb-4">
      <h3 class="title font-weight-bold">Filtros</h3>
    </b-col>
    <b-col cols="12">
      <label for="">Lojistas</label>
      <SelectShopkeeperWithApp
        v-model="filters.shopkeepersIds"
        propValueName="userId"
        @update:value="searchTimeOut()"
      />
    </b-col>
    <b-col cols="12" class="mt-4">
      <input
        type="text"
        class="form-control"
        v-model="filters.name"
        placeholder="Nome do produto, código de barras, marca"
        @input="searchTimeOut"
      />
    </b-col>
    <b-col cols="12" class="mt-4">
      <b-button variant="success" @click="get()" :disabled="loading">
        <i class="fas fa-search mr-2"></i>
        Pesquisar
      </b-button>
      <b-button variant="warning" class="ml-2" @click="filters = {}">
        <i class="fas fa-trash mr-2"></i>
        Limpar
      </b-button>
    </b-col>
    <b-col class="mt-5 mb-2">
      <h3 class="title font-weight-bold">
        Encontrado {{ pagination.total }} produto(s) com preço(s) no total
      </h3>
    </b-col>
    <b-col cols="12">
      <b-table
        striped
        hover
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>
        <template #cell(priceSalesFormat1)="data">
          <span>{{ formatNumber(data.item.priceSalesFormat1) }}</span>
        </template>
        <template #cell(product)="data">
          <span class="spanProduct">
            {{ data.item.product }}
            <img
              :src="linkFotos() + data.item.photo"
              :alt="data.item.product"
              class="imgProduct"
            />
          </span>
        </template>
        <template #cell(withdrawalInOneDay)="data">
          <span>{{ data.item.withdrawalInOneDay ? 'Sim' : 'Não' }}</span>
        </template>
      </b-table>
    </b-col>
    <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
        aria-controls="selectProductsTable"
      ></b-pagination>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import PageTitle from 'Components/PageTitle.vue';
import makeToast from 'Mixins/makeToast';
import SelectShopkeeperWithApp from 'Components/Inputs/SelectShopkeeperWithApp.vue';

export default {
  name: 'SelectProducts',
  mixins: [makeToast],
  components: { PageTitle, SelectShopkeeperWithApp },
  data() {
    return {
      items: null,
      idCategory: null,
      categoryProductId: null,
      categoryProductItems: null,
      filters: {
        shopkeepersIds: [],
      },
      loading: false,
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 0,
      },
      fields: {
        selectedProducts: {},
      },
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'productId',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'product',
            label: 'Produto',
            sortable: true,
          },
          {
            key: 'marca',
            label: 'Marca',
            sortable: true,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'codbar',
            label: 'Cod. barras',
            sortable: true,
          },
          {
            key: 'selectedAt',
            label: 'Selecionado',
            sortable: true,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'priceSalesFormat1',
            label: 'Preço',
            sortable: true,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'quantityStock',
            label: 'Estoque',
            sortable: true,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'discont',
            label: 'Desconto à vista(%)',
            sortable: true,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'withdrawalInOneDay',
            label: 'Retirada em 24h',
            sortable: true,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
        ],
        records: [],
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  watch: {
    'pagination.currentPage': function () {
      this.get();
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    ...mapActions('admin', ['getSelectedProductsGeneral']),
    linkFotos() {
      return process.env.VUE_APP_FOTOS_URL;
    },
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.get();
      }, 800);
    },
    get() {
      this.loading = true;

      this.getSelectedProductsGeneral({
        shopkeepersIds: this.filters.shopkeepersIds,
        productName: this.filters.name,
        currentPage: this.pagination.currentPage,
        familyId: this.filters.family,
      })
        .then((response) => {
          const { perPage, total, data } = response.data.data || {};

          this.pagination.itemsPerPage = perPage || 15;
          this.pagination.total = total;

          this.$set(this.table, 'records', data || []);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatNumber(number) {
      return Intl.NumberFormat('pt-BR', {
        currency: 'BRL',
        style: 'currency',
      }).format(number);
    },
  },
};
</script>

<style scoped>
.danger {
  background: rgb(235, 24, 24);
  color: #fff;
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
}
.imgProduct {
  display: none;
}
.spanProduct {
  cursor: pointer;
}
.spanProduct:hover .imgProduct {
  width: 75px;
  display: block;
  border-radius: 3px;
  border: 1px solid #555;
  position: absolute;
  left: 15px;
  margin-top: -9%;
}
</style>